<button class="button-icon {{ButtonClass}}"
        type="button" 
        (click)="OnClick()"
        [disabled]="IsDisabled"
        [style.max-height]="MaxHeight">
    <ng-content></ng-content>
</button>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/buttons/button-icon/button-icon.html